import React from "react";
import { Outlet } from "react-router";
import { SidebarTrigger } from "@/components/ui/sidebar";

export function UserLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}

